



















import Vue from 'vue';
import Component from 'vue-class-component';

import { bills, user, layout } from '@/modules/shared/shared/store/namespaces';
import { GET_CUSTOMER_ID } from '@/modules/users/store/user.getters';
import { BILLS_FETCH_ALL } from '@/modules/invoicing/store/bills.actions';
import { GET_BILL_LIST } from '@/modules/invoicing/store/bills.getters';
import ResumeListComponent from '@/modules/invoicing/components/ResumeListComponent.vue';
import ListView from '@/modules/invoicing/components/ListView.vue';
import billsRepository from '@/modules/invoicing/repositories/bills.repository';

@Component({
    components: { ListView, ResumeListComponent },
})
export default class BillsView extends Vue {
    loading: boolean = false;
    repositoryFunction: Function = (name, number) => billsRepository.getBill(name);
    type: string = 'factura';

    async mounted() {
        this.changeTitle({
            title: 'FACTURAS DE LOS ÚLTIMOS 12 MESES',
            route: ['FACTURACIÓN'],
        });
        this.loading = true;
        await this.BILLS_FETCH_ALL(this.GET_CUSTOMER_ID);
        this.loading = false;
    }

    @bills.Getter(GET_BILL_LIST) bills;
    @bills.Action(BILLS_FETCH_ALL) BILLS_FETCH_ALL;
    @user.Getter(GET_CUSTOMER_ID) GET_CUSTOMER_ID;
    @layout.Mutation('changeTitle') changeTitle;
}
